
document.addEventListener("DOMContentLoaded", function () {
  const nav = document.querySelector("nav.breadcrumb ul");
  if (!nav) return;

  const listItems = Array.from(nav.querySelectorAll("li"));
  const items = [];

  listItems.forEach((li, index) => {
    const link = li.querySelector("a");
    const name = link ? link.textContent.trim() : li.textContent.trim();
    const item = link ? link.href : window.location.href;

    items.push({
      "@type": "ListItem",
      "position": index + 1,
      "name": name,
      "item": item
    });
  });

  if (items.length === 0) return;

  const breadcrumbJsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items
  };

  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.textContent = JSON.stringify(breadcrumbJsonLd, null, 2);
  document.head.appendChild(script);
});